import {Button, Checkbox, Grid, Typography} from "@material-ui/core";
import GrayHeaderCard from "../../../../../../../../../../ui/cards/gray-header-card/GrayHeaderCard";
import DefaultSelect from "../../../../../../../../../../ui/inputs/selects/default-select/DefaultSelect";
import {useSelector} from "react-redux";
import {Skeleton} from "@material-ui/lab";

const ActivationRequestStep = ({values, setValues, selectedSims}) => {
    const planOptions = useSelector(state => state.ordiniConsipReducer.consipPlans)

    const serviceTypeMenuItems = [
        {value: 'SIM_DATI_E_VOCE', text: 'Voce e Dati'},
        {value: 'SIM_DATI', text: 'Solo Dati'}
    ]

    const handleChange = (e, name) => {
        if (name === 'clearInputs') {
            setValues((old) => ({
                ...old,
                serviceType: '',
                planType: '',
            }))

        }
        setValues((old) => ({
            ...old,
            [name]: e
        }))
    }

    return (
        <>
            <Typography variant='body1'>Rispondi alle seguenti domande per attivare la SIM</Typography>

            <GrayHeaderCard title={<Typography variant='subtitle2'>Che tipo di servizio vuoi attivare?</Typography>}>
                <Grid container alignItems='center' justifyContent='space-between'>
                    <Grid item xs={12} md={6}>
                        {values.serviceType === '' ? <DefaultSelect value={values.serviceType}
                                                                    fullWidth
                                                                    label="Tipo di servizio"
                                                                    handleOnChange={(e) => handleChange(e.target.value, 'serviceType')}
                                                                    menuItems={serviceTypeMenuItems}/> : <Typography
                            variant={"h6"}>{serviceTypeMenuItems.find(mu => mu.value === values.serviceType)?.text}</Typography>}
                    </Grid>

                    {values.serviceType !== '' ?
                        <Button variant='text'
                                color='primary'
                                onClick={() => handleChange('', 'clearInputs')}
                        >Modifica</Button>
                        : null}
                </Grid>
            </GrayHeaderCard>

            {values.serviceType !== '' ?
                <GrayHeaderCard title={<Typography variant='subtitle2'>Scegli la tipologia di piano</Typography>}>
                    {planOptions.loading ?
                        <Skeleton variant="rect" width="100%" height={50}/> :
                        <>
                            {planOptions.data.map((item) => {
                                return (
                                    <Grid container key={`service-type-options-${item.id}`}>
                                        <Grid item container xs={6} md={4} alignItems='center'>
                                            <Checkbox
                                                // disabled={item.qtaDisponibile === 0 || selectedSims.length > item.qtaDisponibile}
                                                checked={item.id === values.planType}
                                                    onClick={() => handleChange(item.id, 'planType')}/>
                                                <Typography variant='subtitle2'>{item.shortNomePiano}</Typography>
                                            </Grid>

                                            <Grid item container xs={6} md={4} alignItems='center'>
                                                <Typography variant='overline' style={{marginRight: '0.5em'}}>Qtà
                                                    disponibile</Typography>
                                                <Typography variant='subtitle2'>{item.qtaDisponibile}</Typography>
                                            </Grid>
                                        </Grid>
                                    )
                                }
                            )}
                        </>
                    }
                </GrayHeaderCard>
                : null}
        </>
    )
}

export default ActivationRequestStep;